"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return QrCodeColumn;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let QrCodeColumn = class QrCodeColumn {
    static async insert(context, qrCode, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(qrCode, [
            'fk_column_id',
            'fk_qr_value_column_id'
        ]);
        const column = await _models.Column.get(context, {
            colId: insertObj.fk_column_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.fieldNotFound(insertObj.fk_column_id);
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, insertObj);
        return this.read(context, qrCode.fk_column_id, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_QRCODE}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_QRCODE}:${columnId}`, column);
        }
        return column ? new QrCodeColumn(column) : null;
    }
    async getValueColumn(context) {
        return _models.Column.get(context, {
            colId: this.fk_qr_value_column_id
        });
    }
    constructor(data){
        Object.assign(this, data);
    }
};
